module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
 ** module id = 10
 ** module chunks = 0
 **/